import React, { useState } from 'react';
import { TextField, Button, InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { productsStyles } from '../styles/ProductsStyles';

// Single fuzzy search box. Reused on the search page and the home page.
// Supports the server's boolean-mode operators: -word (exclude), +word
// (require), "phrase", word* (prefix). onSearch(query) is called on submit.
const SuperSearchBar = ({
  onSearch,
  initialValue = '',
  autoFocus = false,
  placeholder = 'Search products… (try -gray to exclude, "warm oak" for a phrase)',
}) => {
  const productsClasses = productsStyles();
  const [query, setQuery] = useState(initialValue);

  const submit = (e) => {
    e.preventDefault();
    onSearch((query || '').trim());
  };

  return (
    <form onSubmit={submit} style={{ display: 'flex', gap: 8, width: '100%' }}>
      <TextField
        fullWidth
        type="search"
        variant="outlined"
        value={query}
        autoFocus={autoFocus}
        placeholder={placeholder}
        onChange={(e) => setQuery(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
      <Button
        type="submit"
        variant="contained"
        className={productsClasses.productFilterButton}
      >
        Search
      </Button>
    </form>
  );
};

export default SuperSearchBar;
